module.exports = "static/assets/adc0b35e696de431abb9dd3ea90a5deb.svg";